import { Button, NotificationsCounter } from "../UI";
import * as buttonDesignType from "../../builders/buttonDesign.types";
import * as statusTypes from "../../constants/status.constants";
import { FooterActionsStyles } from "./footerActions.styles";

const FooterActions = ({
  status,
  newMessagesCount = 0,
  closeModal,
  toggleChat,
  approveAction,
  declineAction,
  cancelServiceAction,
  startServiceAction,
  pauseServiceAction,
  resumeServiceAction,
  finishServiceAction
}) => {
  switch (status) {
    case statusTypes.ACCEPTED:
      return (
        <FooterActionsStyles>
          <Button
            buttonDesignType={buttonDesignType.SECONDARY}
            onClick={cancelServiceAction}
          >
            Cancel
          </Button>
          <Button
            buttonDesignType={buttonDesignType.PRIMARY}
            onClick={startServiceAction}
          >
            Start service
          </Button>
        </FooterActionsStyles>
      );

    case statusTypes.IN_PROGRESS:
      return (
        <FooterActionsStyles>
          <Button
            buttonDesignType={buttonDesignType.SECONDARY}
            onClick={cancelServiceAction}
          >
            Cancel
          </Button>
          <Button
            buttonDesignType={buttonDesignType.SECONDARY}
            onClick={pauseServiceAction}
          >
            Pause
          </Button>
          <Button
            buttonDesignType={buttonDesignType.PRIMARY}
            onClick={finishServiceAction}
          >
            Finish
          </Button>
        </FooterActionsStyles>
      );

    case statusTypes.PAUSED:
      return (
        <FooterActionsStyles>
          <Button
            buttonDesignType={buttonDesignType.SECONDARY}
            onClick={cancelServiceAction}
          >
            Cancel
          </Button>
          <Button
            buttonDesignType={buttonDesignType.PRIMARY}
            onClick={resumeServiceAction}
          >
            Resume
          </Button>
        </FooterActionsStyles>
      );

    case statusTypes.FINISHED:
    case statusTypes.CANCELED:
    case statusTypes.DECLINED:
    case statusTypes.FLEET_CANCELED:
      return (
        <FooterActionsStyles>
          <Button
            buttonDesignType={buttonDesignType.SECONDARY}
            onClick={closeModal}
          >
            Close
          </Button>
          <Button
            buttonDesignType={buttonDesignType.PRIMARY}
            onClick={toggleChat}
          >
            Chat history
            {newMessagesCount > 0 && (
              <NotificationsCounter
                className="notification-counter"
                counter={newMessagesCount}
              />
            )}
          </Button>
        </FooterActionsStyles>
      );

    case statusTypes.PENDING:
    default:
      return (
        <FooterActionsStyles>
          <Button
            buttonDesignType={buttonDesignType.SECONDARY}
            onClick={declineAction}
          >
            Decline
          </Button>
          <Button
            buttonDesignType={buttonDesignType.PRIMARY}
            onClick={approveAction}
          >
            Approve
          </Button>
        </FooterActionsStyles>
      );
  }
};

export default FooterActions;
